import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

function deviceId(): string {
  let id = localStorage.getItem("unseen_device");
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("unseen_device", id);
  }
  return id;
}

export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });
api.interceptors.request.use((cfg) => {
  cfg.headers["X-Device-Id"] = deviceId();
  return cfg;
});

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (d == null) {
    if (typeof navigator !== "undefined" && navigator.onLine === false) return "Sei offline: controlla la connessione e riprova";
    if (e?.code === "ECONNABORTED" || e?.message === "Network Error") return "Il server non ha risposto. Riprova tra un attimo";
    return "Qualcosa è andato storto, riprova";
  }
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const mediaUrl = (u?: string | null) => (u ? `${BACKEND}${u}` : undefined);

export function timeAgo(isoStr: string): string {
  const s = (Date.now() - new Date(isoStr).getTime()) / 1000;
  if (s < 60) return "ora";
  if (s < 3600) return `${Math.floor(s / 60)} min`;
  if (s < 86400) return `${Math.floor(s / 3600)} h`;
  return `${Math.floor(s / 86400)} g`;
}
